<!-- Desktop: normal popup picker -->
<nz-range-picker
    *ngIf="!isMobile"
    [(ngModel)]="innerValue"
    (ngModelChange)="onDesktopChange($event)"
    [ngModelOptions]="{standalone: true}"
    [nzFormat]="nzFormat"
    [nzDisabledDate]="nzDisabledDate"
    [nzDropdownClassName]="nzDropdownClassName"
></nz-range-picker>

<!-- Mobile: trigger + bottom-sheet overlay (no nz-modal, no CDK) -->
<ng-container *ngIf="isMobile">
    <div class="nz-drp__trigger" (click)="openOverlay()">
        <span nz-icon nzType="calendar" nzTheme="outline" class="nz-drp__trigger-icon"></span>
        <span class="nz-drp__trigger-label" [class.nz-drp__trigger-label--placeholder]="!triggerLabel">
            {{ triggerLabel || placeholder }}
        </span>
        <span nz-icon nzType="down" nzTheme="outline" class="nz-drp__trigger-arrow"></span>
    </div>

    <div class="drp-overlay" *ngIf="overlayVisible" (click)="onBackdropClick($event)">
        <div class="drp-sheet" role="dialog" [attr.aria-label]="title">
            <div class="drp-sheet__header">
                <span class="drp-sheet__title">{{ title }}</span>
                <button type="button" class="drp-sheet__close" (click)="onCancel()" aria-label="Close">
                    <span nz-icon nzType="close" nzTheme="outline"></span>
                </button>
            </div>

            <div class="drp-sheet__body">
                <nz-range-picker
                    [nzInline]="true"
                    [(ngModel)]="tempValue"
                    [ngModelOptions]="{standalone: true}"
                    nzFormat="yyyy-MM-dd"
                    [nzDisabledDate]="nzDisabledDate"
                ></nz-range-picker>
            </div>

            <div class="drp-sheet__footer">
                <button nz-button nzType="default" (click)="onCancel()">{{ cancelLabel }}</button>
                <button nz-button nzType="default" (click)="onClear()">{{ clearLabel }}</button>
                <button nz-button nzType="primary" (click)="onConfirm()">{{ confirmLabel }}</button>
            </div>
        </div>
    </div>
</ng-container>
